var _circle, _circle2, _path, _circle3, _rect, _rect2, _circle4, _path2, _rect3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImagesGalleryEmptyState = function SvgImagesGalleryEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 96,
    fill: "none",
    className: "svgr-icon"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2,
    cy: 16.2,
    r: 9.72,
    fill: "#FFC76C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.7,
    cy: 3.7,
    r: 3.7,
    fill: "#FFC76C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EB6552",
    d: "M111.2 84.3a4.663 4.663 0 0 0 6.45 1.48 4.707 4.707 0 0 0 1.48-6.48 4.663 4.663 0 0 0-6.45-1.48 4.707 4.707 0 0 0-1.48 6.48"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 80,
    r: 8,
    fill: "#EB6552"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 40,
    x: 30,
    y: 22,
    fill: "#9ED8F0",
    rx: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 40,
    x: 26,
    y: 18,
    fill: "#FEE1BF",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    rx: 4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 30,
    r: 4,
    fill: "#FFC76C",
    stroke: "#1D1D1B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "m28 50 12-10 8 6 14-12 12 16"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: 56,
    y: 44,
    fill: "#FEE1BF",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    rx: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M74 54v16M66 62h16"
  })));
};
export default SvgImagesGalleryEmptyState;